import Highlight from './highlight/highlight';
import Selection from './selection';
import { handleMouseEvent } from './mouseEventHandler';
import {
  detectSelectionType,
  normalizeSelectionFactory,
} from './utils';

export {
  handleMouseEvent,
  Highlight,
  Selection,
  detectSelectionType,
  normalizeSelectionFactory
};



// WEBPACK FOOTER //
// ./src/selection/index.js